import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const COLORS: Record<string, string> = {
  draft: 'default',
  published: 'green',
  closed: 'red',
  submitted: 'blue',
  returned: 'green',
  late: 'orange',
  not_submitted: 'default',
};

const LABEL_KEYS: Record<string, [string, string]> = {
  draft: ['lmsDraft', 'Draft'],
  published: ['lmsPublished', 'Published'],
  closed: ['lmsClosed', 'Closed'],
  submitted: ['lmsSubmitted', 'Submitted'],
  returned: ['lmsReturned', 'Returned'],
  late: ['lmsLate', 'Late'],
  not_submitted: ['lmsNotSubmitted', 'Not submitted'],
};

export default function LmsStatusTag({ status }: { status?: string | null }) {
  const { t } = useTranslation('education');
  const value = status || 'draft';
  const [key, fallback] = LABEL_KEYS[value] || [value, value];
  return <Tag color={COLORS[value]}>{t(key, { defaultValue: fallback })}</Tag>;
}
